/**
 * GeneratorPopup Component
 * Displays generator information in a Leaflet popup
 */

import React from 'react';
import type { GeneratorMapPoint } from '@/api/types/generators.types';
import './GeneratorPopup.css';

interface GeneratorPopupProps {
  generator: GeneratorMapPoint;
}

const statusColors = {
  available: '#52c41a',
  rented: '#1890ff',
  maintenance: '#faad14',
  broken: '#ff4d4f',
  decommissioned: '#8c8c8c',
};

const statusLabels = {
  available: 'Dostupan',
  rented: 'Iznajmljen',
  maintenance: 'Na održavanju',
  broken: 'Pokvaren',
  decommissioned: 'Van upotrebe',
};

export const GeneratorPopup: React.FC<GeneratorPopupProps> = ({
  generator,
}) => {
  return (
    <div className="generator-popup">
      <h3>{generator.serial_number}</h3>
      <p className="generator-model">
        <strong>
          {generator.manufacturer} {generator.model}
        </strong>
      </p>
      <p className="generator-status">
        Status:{' '}
        <span style={{ color: statusColors[generator.status] }}>
          {statusLabels[generator.status]}
        </span>
      </p>
      <p className="generator-power">Snaga: {generator.power_kva} kVA</p>
      {generator.current_location && (
        <p className="generator-location">
          Lokacija: {generator.current_location}
        </p>
      )}
    </div>
  );
};
